import {mock} from './index';

export default {
  getAppMenuList: (): void => mock('/admin/app/menu/list'),
  getMenuAddition: (): void => mock('/admin/app/menu/addition/get'),
  setMenuAdditions: (): void => mock('/admin/app/menu/addition/set'),
  setMenuIcon: (): void => mock('/admin/app/menu/icon/set')
};
